import { render, staticRenderFns } from "./PropertyChooseOrCreateCollisionBox.vue?vue&type=template&id=79c86aea&scoped=true&"
import script from "./PropertyChooseOrCreateCollisionBox.vue?vue&type=script&lang=js&"
export * from "./PropertyChooseOrCreateCollisionBox.vue?vue&type=script&lang=js&"
import style0 from "./PropertyChooseOrCreateCollisionBox.vue?vue&type=style&index=0&id=79c86aea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c86aea",
  null
  
)

export default component.exports